<div class="grid grid-cols-12 gap-4 service-line-dialog">
  <div class="col-span-12 px-0">
    <div class="p-form-widget p-form-view-data col-span-12">
      <div class="field flex items-center">
        <label class="font-subheader">You are requesting a skill that has been previously denied.</label>
      </div>
      <div class="flex flex-col p-form-widget p-form-view-data">
        <div class="field">
          <label class="font-interruption">Skill:</label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.skillCode}}</div>
          </div>
        </div>
        <div class="field">
          <label class="font-interruption">Date/Time Request Received: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.dateTimeFaxRecieved | date :'MM/dd/yyyy hh:mm:ss a'}}</div>
          </div>
        </div>
        <div class="field">
          <label class="font-interruption">Denied Visits: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.deniedAmount}}</div>
          </div>
        </div>
        <div class="field">
          <label class="font-interruption">Effective From: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.effectiveFromDate | date :'MM/dd/yyyy hh:mm:ss a'}}</div>
          </div>
        </div>
        <div class="field">
          <label class="font-interruption">Effective To: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.effectiveToDate | date :'MM/dd/yyyy hh:mm:ss a'}}</div>
          </div>
        </div>
        <div class="field">
          <label class="font-interruption">Status Reason: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{deniedVisitDetails.serviceStatusReason}}</div>
          </div>
        </div>
        <div class="field flex items-center">
          <label class="font-interruption-message"><span class="is-required">*</span>Do you have new
        orders indicating a change in frequency or change in diagnosis codes?:</label>
      </div>
      <div class="field">
        <button type="button" pButton icon="" label="Yes" [class]="{'active':selected === 'Yes'}"
        class="mr-2 toggle-button" (click)="onSelect('Yes')"></button>
        <button type="button" pButton icon="" label="No" [class]="{'active':selected === 'No'}"
        class="toggle-button" (click)="onSelect('No')"></button>
      </div>
    </div>
    @if (selected === 'No') {
      <div class="info-box">
        <i class="pi pi-info-circle info-icon"></i>
        <div class="info-content">
          <h4 class="info-title">Next Step for Denied Request</h4>
          <p>
            If you do not have new orders indicating a change in frequency or change in diagnosis codes, the appropriate course of action is to submit an appeal of your previously denied request. Please refer to the denial letter for information on appeal rights.
          </p>
        </div>
      </div>
    }
  </div>
</div>
</div>

<div class="flex justify-end mt-4">
  <button type="button" pButton icon="" label="Cancel" class="mr-2" (click)="cancel()"></button>
  <button type="button" pButton icon="" class="p-button-secondary" label="Request Visit"
  [disabled]="selected !== 'Yes'" (click)="save()"></button>
</div>
